import React, { lazy, Suspense } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import AdminPage from 'components/admin/AdminPage';

const AdminRichTextEditor = lazy(() => import('../AdminRichTextEditor'));
const AdminAddUser = lazy(() => import('../AdminAddUser'));
const AdminEditUser = lazy(() => import('../AdminEditUser'));
const AdminUsers = lazy(() => import('../AdminUsers'));
const AdminOverlays = lazy(() => import('../AdminOverlays'));
const AdminEditOverlay = lazy(() => import('../AdminEditOverlay'));

const Admin = () => {
  const match = useRouteMatch();

  return (
    <AdminPage>
      <Switch>
        <Suspense fallback={<div>Loading...</div>}>
          <Route path={`${match.path}/add-user`} component={AdminAddUser} />
          <Route path={`${match.path}/rich-text`} component={AdminRichTextEditor} />
          <Route path={`${match.path}/users-edit/:id`} component={AdminEditUser} />
          <Route path={`${match.path}/users`} component={AdminUsers} />
          <Route path={`${match.path}/overlays`} component={AdminOverlays} />
          <Route path={`${match.path}/overlays-edit/:id`} component={AdminEditOverlay} />
        </Suspense>
      </Switch>
    </AdminPage>
  );
};

export default Admin;
